import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses, price } from '../data/salesCopy';
export function OfferStack() {
  return <section className="bg-cream py-12 sm:py-24" aria-labelledby="bonos" data-id="element-79" data-mp="2buvmy6p2s9ky">
      <div className="mx-auto max-w-4xl px-4 sm:px-6" data-id="element-80" data-mp="2pvetf9dw77l0">
        <p className="flex items-center gap-2 text-[10px] font-medium uppercase tracking-overline text-rose sm:text-[11px]" data-id="element-81" data-mp="2pssn1d2qmy4d">
          <GiftIcon aria-hidden="true" className="h-4 w-4 shrink-0" data-id="element-82" data-mp="1x5zhmheelao1" />
          Solo por el lanzamiento
        </p>
        <h2 id="bonos" className="mt-4 font-display text-[1.6rem] font-semibold leading-tight text-ink sm:mt-5 sm:text-4xl" data-id="element-83" data-mp="1t5p2of8mv9x1">
          Los 5 bonos que te llevás hoy sin pagar un peso extra
        </h2>

        <ul className="mt-8 space-y-3 sm:mt-12 sm:grid sm:grid-cols-2 sm:gap-4 sm:space-y-0" data-id="element-84" data-mp="224j54m8nauii">
          {bonuses.map(item => <li key={item.label} className="flex h-full flex-col rounded-2xl bg-cream-deep p-5 ring-1 ring-ink/10 sm:p-6" data-id="element-85" data-mp="1eeori2gi51x7">
              <p className="text-[10px] font-medium uppercase tracking-overline text-ink/50 sm:text-[11px]" data-id="element-86" data-mp="19eu3c6o42qfu">
                {item.label}
              </p>
              <h3 className="mt-2 font-display text-lg leading-snug text-ink sm:text-xl" data-id="element-87" data-mp="19nepef9c2c6f">
                {item.title}
              </h3>
              <p className="mt-2 text-[14px] leading-relaxed text-ink/70 sm:text-sm" data-id="element-88" data-mp="1efogvzq3jkat">
                {item.description}
              </p>
              <p className="mt-auto pt-4 text-[13px] sm:pt-5 sm:text-sm" data-id="element-89" data-mp="lqhdambsc4ip">
                <span className="text-ink/45 line-through" data-id="element-90" data-mp="lskbvur075z1">Valor {item.value}</span>
                <span className="ml-2 font-semibold uppercase tracking-[0.08em] text-rose" data-id="element-91" data-mp="qpke1ukqfokv">
                  {item.tag}
                </span>
              </p>
            </li>)}
        </ul>

        <p className="mt-8 border-t border-ink/15 pt-6 text-center font-display text-lg text-ink sm:mt-12 sm:pt-8 sm:text-2xl" data-id="element-92" data-mp="zrblb3ux83gu">
          Valor total de los 5 bonos:{' '}
          <span className="whitespace-nowrap text-rose" data-id="element-93" data-mp="2b44aq808oftq">{price.bonusesTotal}</span> — hoy van
          incluidos gratis.
        </p>
      </div>
    </section>;
}